import { CreditsPerMonth, CreditsPerYear } from 'constants/credits';
import React, { useRef } from 'react';
import {
    ColorMode,
    Flex,
    InfoOutlined,
    Popover,
    useBreakpoint,
} from '@landr/maestro';
import { Interval } from 'types/generated/subscriptionsApi';
import { Trans } from '@lingui/macro';
import Plan from '../Plan/Plan';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';
import useSamplePlan from './useSamplePlan';

const SampleUsp = ({
    frequency,
    isMobile,
}: {
    frequency: Interval;
    isMobile: boolean;
}) => {
    const popOverAnchorRef = useRef<HTMLDivElement>(null);

    return (
        <ul>
            <li>
                {frequency === 'Monthly' ? (
                    <Trans>{CreditsPerMonth} credits per month</Trans>
                ) : (
                    <Trans>{CreditsPerYear} credits per year</Trans>
                )}
            </li>
            <li>
                <Trans>Weekly pack giveaway</Trans>
            </li>

            <li>
                <Flex alignItems="center">
                    <Trans>Unlimited access to Chromatic</Trans>

                    <Flex
                        alignItems="center"
                        ref={popOverAnchorRef}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <ColorMode mode="dark">
                            <Popover
                                hasArrow
                                placement="top"
                                triggerEvent={isMobile ? 'click' : 'hover'}
                                anchorRef={popOverAnchorRef}
                            >
                                <Popover.Trigger>
                                    <InfoOutlined
                                        color="neutral.500"
                                        size="sm"
                                    />
                                </Popover.Trigger>
                                <Popover.Content>
                                    <Trans>Loop-based instrument.</Trans>
                                </Popover.Content>
                            </Popover>
                        </ColorMode>
                    </Flex>
                </Flex>
            </li>
        </ul>
    );
};

const SamplePlan = () => {
    const isMobile = useBreakpoint('md');

    const {
        frequency,
        hasSubscription,
        samplesCatalog,
        selectedPlan,
        handlePlanSelect,
        getDiscountedPlan,
    } = useUpsellActionsContext();

    const {
        code,
        currency,
        info,
        monthlyEquivalentPrice,
        monthlyEquivalentSale,
        salePrice,
        subscriptionPrice,
        title,
    } = useSamplePlan({
        frequency,
        hasSubscription,
        samplesCatalog,
        getDiscountedPlan,
    });

    return (
        <Plan
            activePlanCode={selectedPlan}
            code={code}
            currency={currency}
            frequency={frequency}
            monthlyEquivalentPrice={monthlyEquivalentPrice}
            subscriptionPrice={subscriptionPrice}
            title={title}
            info={info}
            usp={<SampleUsp frequency={frequency} isMobile={isMobile} />}
            handlePlanSelect={handlePlanSelect}
            salePrice={salePrice}
            monthlyEquivalentSale={monthlyEquivalentSale}
        />
    );
};

export default SamplePlan;
